import { z } from 'zod';

// Zod 4 prüft standardmäßig per `new Function`, ob dynamische Codeerzeugung erlaubt ist, und erzeugt
// damit bei strikter CSP (`script-src 'self'` ohne `unsafe-eval`) Verstoßmeldungen. Der JIT-Modus wird
// deshalb abgeschaltet. Das Modul muss als erstes importiert werden, bevor Schemas angelegt werden.
z.config({ jitless: true });
